import { render, staticRenderFns } from "./GroupsByModuleList.vue?vue&type=template&id=021d986e"
import script from "./GroupsByModuleList.vue?vue&type=script&lang=ts"
export * from "./GroupsByModuleList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports